import React, {useState} from 'react';
import {PickerView} from 'zarm';
import './index.less';
// 镜片状况
const dataList = [
  [
    {value: 0, label: '——'},
    {value: 1, label: '沉淀'},
    {value: 2, label: '无沉淀'},
    {value: 3, label: '少沉淀'},
  ],
  [
    {value: 0, label: '——'},
    {value: 1, label: '划痕'},
    {value: 2, label: '无划痕'},
    {value: 3, label: '少划痕'},
  ],
];
const SubsideStatus = ['——', '沉淀', '无沉淀', '少沉淀'];
const scratchStatus = ['——', '划痕', '无划痕', '少划痕'];
class OpticCondition extends React.Component {
  constructor(props) {
    super(props);
    this.examOdContent = [];
    this.examOsContent = [];
  }
  onChange = (selected, type) => {
    const selectList = selected.map((item) => item.label);
    if (type === 'OD') {
      this.examOdContent = selectList;
    }
    if (type === 'OS') {
      this.examOsContent = selectList;
    }
  };
  /*
   * 回调方法
   */
  handleResult = () => {
    const {data} = this.props;
    const {examContent, ...rest} = data;
    const {examOdContent, examOsContent} = this;
    const [dataOdSubside, dataOdScratch] = [examOdContent[0], examOdContent[1]];
    const [dataOsSubside, dataOsScratch] = [examOsContent[0], examOsContent[1]];
    const opticData = {
      dataOdSubside,
      dataOdScratch,
      dataOsSubside,
      dataOsScratch,
    };
    const params = {
      ...rest,
      examContent: opticData,
    };
    return params;
  };
  render() {
    const {
      dataOdSubside = '无沉淀',
      dataOdScratch = '无划痕',
      dataOsSubside = '无沉淀',
      dataOsScratch = '无划痕',
    } = this.props.data.examContent;
    const odData = [
      SubsideStatus.findIndex((value) => value === dataOdSubside),
      scratchStatus.findIndex((value) => value === dataOdScratch),
    ];
    const osData = [
      SubsideStatus.findIndex((value) => value === dataOsSubside),
      scratchStatus.findIndex((value) => value === dataOsScratch),
    ];
    this.examOdContent = [dataOdSubside, dataOdScratch];
    this.examOsContent = [dataOsSubside, dataOsScratch];
    return (
      <span>
        <div className="opticCondition">
          {['OD', 'OS'].map((type, index) => {
            return (
              <div className="container" key={index}>
                <p
                  className="title"
                  style={{
                    background: index === 0 ? '#c3fff4' : '#DBF4FE',
                    color: index === 0 ? '#00A185 ' : '#00BAFF',
                  }}
                >
                  {type}
                </p>
                <p className="select">
                  <PickerView
                    defaultValue={index === 0 ? odData : osData}
                    dataSource={dataList}
                    onChange={(selected, index) => {
                      this.onChange(selected, type);
                    }}
                  />
                </p>
              </div>
            );
          })}
        </div>
      </span>
    );
  }
}

export default OpticCondition;
